import "../../styles/legacy-css/LoginPopup.css";
import { useLoginStageContext } from "../../contexts/LoginStageContext";
import { useState } from "react";
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import UserPool from "../../services/aws/UserPool";
import AWS from "aws-sdk";
import {
  cognitoIdentityCredentials,
  useAccountContext,
  userSubscriptionData,
} from "../../contexts/Account";
import { itemDataFromDynamo } from "../../contexts/UserDataContext";
import { StyledPopupErrorMessage } from "../../styles/components/Popup.styled";
import axios from "axios";
import { LoadingPopup } from "./Loading";
import { createApiClient } from "../../utils";

//function for displaying the login content as a popup
function LoginPopup() {
  const { setLoginStage, setLoginMessage } = useLoginStageContext();
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loginErrProps, setLoginFailed] = useState<loginFailureProps>({
    loginFailed: false,
    loginErrMessage: "",
  });

  if (isLoggingIn) {
    return <LoadingPopup message="Logging in..." />;
  }

  return (
    <div className="login-popup">
      <div className="login-popup-inner">
        <button
          className="close-btn"
          aria-label="Close"
          onClick={() => {
            setLoginMessage(null);
            setLoginStage("none");
          }}
        >
          &times;
        </button>
        <Login
          setIsLoggingIn={setIsLoggingIn}
          loginErrProps={loginErrProps}
          setLoginFailed={setLoginFailed}
        />
      </div>
    </div>
  );
}

interface cognitoUser {
  email: string;
  password: string;
}

//interface for managing login error state
interface loginFailureProps {
  loginFailed: boolean;
  loginErrMessage: string;
}

var sessionUserAttributes: any;
var cognitoUser: cognitoUser;

interface LoginProps {
  setIsLoggingIn: React.Dispatch<React.SetStateAction<boolean>>;
  loginErrProps: loginFailureProps;
  setLoginFailed: React.Dispatch<React.SetStateAction<loginFailureProps>>;
}

const Login = ({ setIsLoggingIn, loginErrProps, setLoginFailed }: LoginProps) => {
  const navigate = useNavigate();
  const {
    setLoggedInUserCognitoIdToken,
    setUserCognitoAttrubutes,
    loggedInUserCognitoIdToken,
    setSubscriptionDetails
  } = useAccountContext();
  const { setLoginStage, loginMessage, setLoginMessage } = useLoginStageContext();
  const [userItemInfo, setUserItemInfo] = useState<{
    itemHashMap: Record<string, itemDataFromDynamo>;
    searchHashMap: Record<string, Set<string>>;
    parentHashMap: Record<string, Set<string>>;
  } | void>();

  const handleSubmit = async (e: any, values: cognitoUser) => {
    e.preventDefault();
    setIsLoggingIn(true);
    setLoginMessage(null);
    setLoginFailed({ loginFailed: false, loginErrMessage: "" });

    const cognitoUser = new CognitoUser({
      Username: values.email,
      Pool: UserPool,
    });

    const authenticationDetails = new AuthenticationDetails({
      Username: values.email,
      Password: values.password,
    });

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (r: CognitoUserSession) => {
        sessionUserAttributes = cognitoUser.getUserAttributes(function (
          err,
          result
        ) {
          if (err) {
            console.log("err", err);
            return;
          }

          //On Login, set the idtoken for the user
          setLoggedInUserCognitoIdToken(r.getIdToken().getJwtToken());

          const obj = result?.reduce(
            (obj, item) => ({
              ...obj,
              [item.Name]: item.Value,
            }),
            {}
          );
          window.localStorage.setItem(
            "UserCognitoAttrubutes",
            JSON.stringify(obj)
          );
          window.localStorage.setItem(
            "CognitoIdToken",
            r.getIdToken().getJwtToken()
          );
          setUserCognitoAttrubutes(obj!);

          // Get User Subscription Status
          const api = createApiClient(r.getIdToken().getJwtToken());
          api
            .get<userSubscriptionData>(
              process.env.REACT_APP_AWS_SUBSCRIPTION_API_URL!
            )
            .then((response) => {
              const subscriptionData = response.data;
              setSubscriptionDetails(subscriptionData);
            })
            .catch((error) => {
              console.error("Failed to fetch subscription data:", error);
              // User can still access the app even if subscription check fails
            });

          setLoginStage("none");
          setIsLoggingIn(false);
          navigate("/MyItems");
        });
      },
      onFailure: (err) => {
        console.log("login failed", err);
        setLoginFailed({ loginFailed: true, loginErrMessage: err.message });
        setIsLoggingIn(false);
      },
      newPasswordRequired: () => {
        cognitoUser.completeNewPasswordChallenge(
          process.env.REACT_APP_DEFAULT_PWD!,
          sessionUserAttributes,
          {
            onSuccess: (result) => {
              // login
            },
            onFailure: (result) => {
              // login
            },
          }
        );
      },
    });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: (values: cognitoUser) => {
      //handleSubmit(values);
    },
  });

  return (
    <>
      <div>
        <form onSubmit={() => formik.handleSubmit}>
          <h1>Sign In</h1>

          <div className="login__fieldName" id="email" data-lpignore="true">
            Email Address
          </div>
          <input
            className="login__inputField"
            name="email"
            type="email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            data-lpignore="true"
            autoComplete="off"
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="login__error">{formik.errors.email}</div>
          ) : null}

          <div className="login__fieldName" id="password">
            Password
          </div>
          <input
            className="login__inputField"
            name="password"
            type="password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            data-lpignore="true"
            autoComplete="off"
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="login__error">{formik.errors.password}</div>
          ) : null}

          <div
            style={{
              width: "50%",
              minWidth: "250px",
              textAlign: "right",
              marginTop: "-10px",
              marginBottom: "15px",
            }}
          >
            <a
              href="#"
              style={{ color: "#ffffff", fontSize: "14px" }}
              onClick={(e) => {
                e.preventDefault();
                setLoginStage("forgot_password");
              }}
            >
              Forgot Password?
            </a>
          </div>

          {loginMessage != null && (
            <>
              <div>{loginMessage}</div> <br />
            </>
          )}

          <div>
            <button
              className="login__submitButton"
              onClick={(e) => handleSubmit(e, formik.values)}
            >
              Login
            </button>
            {loginErrProps.loginFailed && (
              <StyledPopupErrorMessage>
                {loginErrProps.loginErrMessage}
              </StyledPopupErrorMessage>
            )}
          </div>

          <hr
            style={{
              margin: "20px 0",
              border: "none",
              borderTop: "1px solid rgba(255, 255, 255, 0.4)",
            }}
          />

          <div>
            Don't have an account? Start for free{" "}
            <a
              href="#"
              style={{ color: "#ffffff", fontWeight: 700, textDecoration: "underline" }}
              onClick={(e) => {
                e.preventDefault();
                setLoginStage("register");
              }}
            >
              here
            </a>
            .
          </div>
        </form>
      </div>
    </>
  );
};

export default LoginPopup;
